<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="4">
          <AutoCustomer @clear="clearCustomerName" :size="'mini'" @handleSelect="afterSelExternalDept"></AutoCustomer>
        </el-col>
        <el-col :span="4">
          <CommonTree ref="treeDserial" :treeHeight="180" :inputSize="'mini'" :searchText="serveuname" @check="changeServer"
                      placeholder="请选择填写人"
                      :isShowCheckBox="false"></CommonTree>
        </el-col>
        <el-col :span="14">
          <el-date-picker
            v-model="searchdate" size="mini"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 250px"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <el-input style="width:200px;" size="mini"
                    placeholder="请输入内容"
                    prefix-icon="el-icon-search"
                    v-model="remark" clearable>
          </el-input>
          <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
          <el-button type="warning" v-model="searchdata" @click="add" size="mini">新增</el-button>
        </el-col>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="thistableHeight()"
      size="mini"
      border
      style="width: 100%;"
    >
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="customername"
        label="客户名称"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="uname" width="100"
        label="填写人"
        align="left"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="日期"
        align="left" width="150"
        header-align="center"
      >
      </el-table-column>
      <el-table-column label="内容" align="left" header-align="center" prop="remark">
      </el-table-column>
      <el-table-column label="操作" align="center" width="175">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.$index, scope.row,$event)">编辑</el-button>
          <el-button size="mini" type="danger" v-if="uguid==scope.row.uguid" @click="remove(scope.$index, scope.row,$event)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
    <TrackingLogEdit ref="TrackingLogEdit" @bindGrid="bindGrid"></TrackingLogEdit>
  </div>
</template>
<script>

  import {getListData, remove} from '@/api/set/trackinglog';
  import TrackingLogEdit from './TrackingLogEdit';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'TrackingLog',
    data() {
      return {
        uguid: '',
        canview: false,
        dialogVisible: false,
        which_to_show: "",
        EditData: [],
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 0,
          total: 0
        },
        tableData: [],
        customerserial: '',//客户编码
        customername: '',//客户名称
        serveuguid: '',//操作人员编码
        serveuname: '',//操作人员
        searchdate: [],//时间范围
        remark: ''//
      }
    },
    props: {
      auditstatus: {
        default: ""
      }
    },
    methods: {
      //删除
      remove(index, row) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          remove({unitguid: row.unitguid}).then(response => {
            if (response.data.code == 0) {
              this.$message({
                duration: 1500,
                type: 'success',
                message: '操作成功!'
              });
            } else {
              this.$message.error('操作失败')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '取消删除'
          });
        });
      },
      //增加
      add() {
        this.dailog()
      },
      //修改
      edit(index, row) {
        this.dailog()
        this.$refs.TrackingLogEdit.initData(row.unitguid)
      },
      dailog() {
        this.$refs.TrackingLogEdit.show(this.auditstatus)
      },
      thistableHeight() {
        return this.tableHeight(116);
      },
      clearCustomerName() {
        this.customername = ""
        this.customerserial = ""
        this.bindGrid()
      },
      //查询条件的门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.customername = customername
        this.customerserial = customerserial
        this.bindGrid()
      },
      //销售客服选择后
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },
      //绑定分页参数
      bindGrid() {
        this.getWaitaudit();
      },
      getWaitaudit() {
        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          auditstatus:this.auditstatus,
          customerserial: this.customerserial,
          uguid: this.serveuguid,
          remark: this.remark,
          beginDate: this.searchdate == [] ? '' : this.searchdate[0],
          endDate: this.searchdate == [] ? '' : (this.searchdate[1] + '59:59:59'),
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        })
      },

    },
    mounted() {
      let model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.uguid = model.uguid;
      this.bindGrid();
    },
    components: {TrackingLogEdit}
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/TrackingLog.vue